import { useEffect, useRef, type ComponentProps } from "react";
import { useAttachmentUrl } from "@/hooks/use-attachment-url";

export function AttachmentImage({
  src = "",
  onError,
  ...props
}: ComponentProps<"img">) {
  const { url, error, refresh } = useAttachmentUrl(src);
  const retried = useRef(false);
  useEffect(() => {
    retried.current = false;
  }, [src]);
  return (
    <img
      {...props}
      src={url || undefined}
      title={error ?? props.title}
      onError={(event) => {
        if (!retried.current) {
          retried.current = true;
          refresh();
        }
        onError?.(event);
      }}
    />
  );
}

export function AttachmentVideo({
  src = "",
  onError,
  ...props
}: ComponentProps<"video">) {
  const { url, error, refresh } = useAttachmentUrl(src);
  const retried = useRef(false);
  useEffect(() => {
    retried.current = false;
  }, [src]);
  return (
    <video
      {...props}
      src={url || undefined}
      title={error ?? props.title}
      onError={(event) => {
        if (!retried.current) {
          retried.current = true;
          refresh();
        }
        onError?.(event);
      }}
    />
  );
}

export function AttachmentLink({
  href = "",
  onClick,
  ...props
}: ComponentProps<"a">) {
  const { url, error, refresh } = useAttachmentUrl(href);
  return (
    <a
      {...props}
      href={url || undefined}
      title={error ?? props.title}
      aria-disabled={!url}
      onClick={(event) => {
        if (!url) {
          event.preventDefault();
          refresh();
          return;
        }
        onClick?.(event);
      }}
    />
  );
}
